import { Injectable } from '@angular/core';

import { getAccountFullName } from 'app/utils/account';
import { SnkModifier, AppQuote as Quote } from 'graphql/models/extended';

@Injectable({
  providedIn: 'root'
})
export class OfferMapperService {
  constructor() { }

  mapSnkModifier(quote: Quote): SnkModifier {
    return {
      name: getAccountFullName(quote.snkModifier),
      username: (quote.snkModifier && quote.snkModifier.username) || ''
    } as SnkModifier;
  }
}
